import React, { useState } from 'react';
import { SectionHead, Icon } from './Primitives';
import './UnityUseCases.css';
const cases = [
  {
    title: 'Internal training',
    line: 'Your policies deserve more than a shared folder.',
    text: 'Turn operational knowledge into structured training for the people who need to use it.',
    tag: 'Policies · Onboarding · Technical knowledge',
  },
  {
    title: 'Safety & procedures',
    line: 'When the procedure changes, help people catch up.',
    text: 'Prepare relevant training from approved source material, review it with your experts and deliver it to the right group.',
    tag: 'Procedures · Risk response · Refresher training',
  },
  {
    title: 'Training providers',
    line: 'Create once. Run your next cohort with confidence.',
    text: 'Reuse programmes, organise intakes, guide facilitators and follow learner progress from one connected system.',
    tag: 'Cohorts · Assessments · Delivery management',
  },
  {
    title: 'Funded learning',
    line: 'Give every supported learner a clearer line of sight.',
    text: 'Bring scoped portfolio reporting to funders and supervisors so the next conversation starts with learning evidence.',
    tag: 'Learnerships · Bursaries · Sponsor oversight',
  },
];
export default function UnityUseCases({ assetBase }) {
  const [active, setActive] = useState(0);
  const item = cases[active];
  return (
    <section className="ul-section ul-usecases" id="use-cases">
      <div className="ul-container">
        <SectionHead
          eyebrow="Built around real training needs"
          title="Where knowledge needs to become action."
        />
        <div className="ul-case-tabs" aria-label="Training use case">
          {cases.map((c, i) => (
            <button
              type="button"
              key={c.title}
              aria-pressed={i === active}
              onClick={() => setActive(i)}
            >
              {c.title}
            </button>
          ))}
        </div>
        <div className="ul-case-panel">
          <img
            src={`${assetBase}/workplace-learning.webp`}
            alt="Two professionals reviewing learning material on a tablet in an industrial training room"
            width="1536"
            height="1024"
            loading="lazy"
          />
          <div className="ul-case-copy" aria-live="polite">
            <span className="ul-case-index">0{active + 1} / UNITY IN PRACTICE</span>
            <h3>{item.line}</h3>
            <p>{item.text}</p>
            <span className="ul-case-tag">{item.tag}</span>
            <a href="#pricing" className="ul-small-link">
              Find your starting point <Icon size={17} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
